/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Openegs_Store1Inputs */

const id_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toko`)
};

const ms_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedai`)
};

const da_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butik`)
};

const de_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store`)
};

const en_us2_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store`)
};

const es_es2_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda`)
};

const es_mx2_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda`)
};

const fil_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindahan`)
};

const fr_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boutique`)
};

const it_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negozio`)
};

const hu_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolt`)
};

const nl_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winkel`)
};

const no_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butikk`)
};

const pl_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklep`)
};

const pt_br2_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store`)
};

const pt_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loja`)
};

const ro_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magazin`)
};

const fi_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauppa`)
};

const sv_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butik`)
};

const vi_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cửa hàng`)
};

const tr_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza`)
};

const cs_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod`)
};

const bg_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазин`)
};

const ru_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазин`)
};

const uk_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазин`)
};

const ar_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المتجر`)
};

const hi_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टोर`)
};

const th_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ร้านค้า`)
};

const ja_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストア`)
};

const zh_cn2_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store`)
};

const zh_hant1_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store`)
};

const ko_components_openegs_store1 = /** @type {(inputs: Components_Openegs_Store1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store`)
};

/**
* | output |
* | --- |
* | "Store" |
*
* @param {Components_Openegs_Store1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_openegs_store1 = /** @type {((inputs?: Components_Openegs_Store1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Openegs_Store1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_openegs_store1(inputs)
	if (locale === "ms") return ms_components_openegs_store1(inputs)
	if (locale === "da") return da_components_openegs_store1(inputs)
	if (locale === "de") return de_components_openegs_store1(inputs)
	if (locale === "en-US") return en_us2_components_openegs_store1(inputs)
	if (locale === "es-ES") return es_es2_components_openegs_store1(inputs)
	if (locale === "es-MX") return es_mx2_components_openegs_store1(inputs)
	if (locale === "fil") return fil_components_openegs_store1(inputs)
	if (locale === "fr") return fr_components_openegs_store1(inputs)
	if (locale === "it") return it_components_openegs_store1(inputs)
	if (locale === "hu") return hu_components_openegs_store1(inputs)
	if (locale === "nl") return nl_components_openegs_store1(inputs)
	if (locale === "no") return no_components_openegs_store1(inputs)
	if (locale === "pl") return pl_components_openegs_store1(inputs)
	if (locale === "pt-BR") return pt_br2_components_openegs_store1(inputs)
	if (locale === "pt") return pt_components_openegs_store1(inputs)
	if (locale === "ro") return ro_components_openegs_store1(inputs)
	if (locale === "fi") return fi_components_openegs_store1(inputs)
	if (locale === "sv") return sv_components_openegs_store1(inputs)
	if (locale === "vi") return vi_components_openegs_store1(inputs)
	if (locale === "tr") return tr_components_openegs_store1(inputs)
	if (locale === "cs") return cs_components_openegs_store1(inputs)
	if (locale === "bg") return bg_components_openegs_store1(inputs)
	if (locale === "ru") return ru_components_openegs_store1(inputs)
	if (locale === "uk") return uk_components_openegs_store1(inputs)
	if (locale === "ar") return ar_components_openegs_store1(inputs)
	if (locale === "hi") return hi_components_openegs_store1(inputs)
	if (locale === "th") return th_components_openegs_store1(inputs)
	if (locale === "ja") return ja_components_openegs_store1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_openegs_store1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_openegs_store1(inputs)
	return ko_components_openegs_store1(inputs)
});
export { components_openegs_store1 as "components.openEgs.store" }